import { AppLayout, Flash } from 'AWS-UI-Components-React';
import React from 'react';

function AccessRestrictedComponent(Component) {
  return function WithAlertComponent({featureList, appId, alertMessage, ...props}) {
    if (featureList && featureList.includes(appId)) {
      return <Component { ...props } />;
    }
    return (
      <div>
        <AppLayout
          className="awsui-util-no-gutters"
          content={ <Flash type="error" content={ alertMessage } /> }
          navigationHide={ true } toolsHide={ true } />
      </div>
    );
  };
}

export default AccessRestrictedComponent;


// WEBPACK FOOTER //
// ./src/components/access_restricted_component.jsx